"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputLabel = void 0;
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var classnames_1 = __importDefault(require("classnames"));
var index_1 = require("../index");
var useStyles = (0, react_jss_1.createUseStyles)({
    root: {
        display: 'block',
    },
    required: {
        paddingLeft: 2,
    },
});
var InputLabel = function (props) {
    var styles = useStyles();
    var children = props.children, required = props.required, id = props.id;
    return (react_1.default.createElement(index_1.Typography, { uppercase: true, variant: "textSmall", weight: 'bold', component: 'div', margin: 'xs', className: (0, classnames_1.default)(styles.root, 'input-label') },
        react_1.default.createElement("label", { htmlFor: id, className: 'input-label' },
            children,
            required && react_1.default.createElement("span", { className: styles.required }, "*"))));
};
exports.InputLabel = InputLabel;
//# sourceMappingURL=InputLabel.js.map